import { render, staticRenderFns } from "./TripAdvisor.vue?vue&type=template&id=62ca82f7&scoped=true&"
import script from "./TripAdvisor.vue?vue&type=script&lang=js&"
export * from "./TripAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca82f7",
  null
  
)

export default component.exports